import { addTokenToUrl, ApiClient } from "@/services/apiClient";
import { type ArticleId, type Article, type ArticlesGetOptions } from "./articlesTypes";

type ApiResponse_ArticlesList = {
  status: "ok";
  articles: Article[];
};

type ApiResponse_GetArticle =
  | {
      status: "not-found";
    }
  | {
      status: "ok";
      article: Article;
      related: Article[];
    };

export async function getArticles(options: ArticlesGetOptions): Promise<Article[]> {
  const params = {
    perPage: options.perPage ?? 10,
    offset: options.offset ?? 0,
    categoryId: options.categoryId ?? undefined,
  };
  const url = "articles/get";

  return ApiClient.getPublic<ApiResponse_ArticlesList>(url, params).then(({ data }) => data.articles);
}

export async function getArticle(id: ArticleId, slug: string): Promise<{ article: Article; relatedArticles: Article[] }> {
  const params = { id, url: slug };
  const url = "articles/get-article";
  return ApiClient.getPublic<ApiResponse_GetArticle>(url, params).then((response) => {
    const status = response.data.status;
    if (status === "ok") {
      return {
        article: response.data.article,
        relatedArticles: response.data.related,
      };
    } else {
      throw new Error("Article not found.");
    }
  });
}

/** Old-style BE response - BE rework needed @todo */
type ApiResponse_GetArticleDraft =
  | {
      status: "ok";
      article: Article;
    }
  | {
      status: "error";
    };

export async function getArticleDraft(id: ArticleId, slug: string): Promise<{ article: Article; relatedArticles: Article[] }> {
  const params = { id, url: slug };
  const url = addTokenToUrl("articles/get-article-draft");
  return ApiClient.get<ApiResponse_GetArticleDraft>(url, params).then(({ data }) => {
    const status = data.status;
    if (status === "ok") {
      return {
        article: data.article,
        relatedArticles: [],
      };
    } else {
      throw new Error("Article not found.");
    }
  });
}
